/**
 * Markdown curto dos manuais (Área do PCP): **negrito**, *itálico*,
 * `código`, listas com "- " e quebras de linha. Nada além disso — sem link,
 * imagem nem HTML.
 *
 * Segurança em duas camadas: o texto é ESCAPADO antes de qualquer marcação
 * (o que a pessoa digitou nunca vira tag), e o resultado ainda passa pelo
 * DOMPurify com lista fechada de tags e nenhum atributo.
 */
import DOMPurify from "dompurify";

const TAGS_PERMITIDAS = ["strong", "em", "code", "br", "ul", "li", "p"];

function escapar(texto) {
  return texto
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Marcação de uma linha já escapada. O código vem antes: dentro dele `**` é texto. */
function marcarLinha(linha) {
  const partes = linha.split(/(`[^`]+`)/g);
  return partes
    .map((parte) => {
      if (/^`[^`]+`$/.test(parte)) return `<code>${parte.slice(1, -1)}</code>`;
      return parte
        .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
        .replace(/(^|[^*])\*([^*\s][^*]*)\*/g, "$1<em>$2</em>");
    })
    .join("");
}

/** HTML seguro a partir do markdown curto. Texto vazio vira "". */
export function markdownCurtoParaHtml(texto) {
  if (!texto) return "";
  const linhas = escapar(String(texto)).split("\n");
  const blocos = [];
  let lista = null;
  let paragrafo = [];

  const fecharParagrafo = () => {
    if (paragrafo.length) blocos.push(`<p>${paragrafo.join("<br>")}</p>`);
    paragrafo = [];
  };
  const fecharLista = () => {
    if (lista) blocos.push(`<ul>${lista.map((item) => `<li>${item}</li>`).join("")}</ul>`);
    lista = null;
  };

  linhas.forEach((linhaCrua) => {
    const linha = linhaCrua.trimEnd();
    const item = linha.match(/^\s*[-•]\s+(.*)$/);
    if (item) {
      fecharParagrafo();
      lista = lista || [];
      lista.push(marcarLinha(item[1]));
      return;
    }
    fecharLista();
    if (!linha.trim()) {
      fecharParagrafo();
      return;
    }
    paragrafo.push(marcarLinha(linha));
  });
  fecharParagrafo();
  fecharLista();

  return DOMPurify.sanitize(blocos.join(""), { ALLOWED_TAGS: TAGS_PERMITIDAS, ALLOWED_ATTR: [] });
}

/** Texto puro (sem as marcas), para busca, título de aba e leitores de tela. */
export function markdownCurtoParaTexto(texto) {
  return String(texto || "")
    .replace(/\*\*|__|`/g, "")
    .replace(/(^|\s)\*([^*\s][^*]*)\*/g, "$1$2")
    .replace(/^\s*[-•]\s+/gm, "")
    .trim();
}
